/**
 * @enum RewardScarcity
 * @description The scarcity of a reward
 */
enum RewardScarcity {
    COMMON = "COMMON",
    UNCOMMON = "UNCOMMON",
    RARE = "RARE",
    EPIC = "EPIC",
    LEGENDARY = "LEGENDARY"
};

export default RewardScarcity;